'use client'

import React, { useEffect, useState, useRef, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import axios from 'axios'
import { Popover, Form, Select, Spin, Table, Tooltip, Button } from "antd";
import toast from 'react-hot-toast';
import { MdStar } from "react-icons/md";
import Image from 'next/image';
// import Cookies from 'js-cookie';
// import type { DatePickerProps } from 'antd';
import { DatePicker, Space } from 'antd';
// import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import { GoSignIn } from 'react-icons/go';
import { redirect, useRouter } from 'next/navigation';
import Link from 'next/link';

const { Option } = Select;

export default function KeywordPlanner() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { RangePicker } = DatePicker;
  const [selectedDates, setSelectedDates] = useState([
    dayjs().startOf('month'),
    dayjs().startOf('month').subtract(3, 'month')
  ]);
  // const [selectedDates, setSelectedDates] = useState([]);
  const dateFormat = 'YYYY/MM/DD';
  const formatDates = (dates) => {
    const startMonthYear = dayjs(dates[0]).format('MMMM YYYY');
    const endMonthYear = dayjs(dates[1]).format('MMMM YYYY');
    return { startMonthYear, endMonthYear };
  };

  const { startMonthYear, endMonthYear } = formatDates(selectedDates);
  const [showlanguage, setshowlanguage] = useState(false)
  const router = useRouter()

  const handlePageChange = (page) => {
    // console.log(page);
    
    if (page > 1 ) {
        toast.error('Sign Up For Deatiled Analysis', {
            position: "bottom-center",
            style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
            },
            icon: <GoSignIn className='text-xl' />,

        });
        window.open("https://app.w3era.com/tools/keyword-research", "_blank");
        return;
    }
    setCurrentPage(page);
};

  const handleDateChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      const startMonthYear = dayjs(dates[0]).format('MMMM YYYY');
      const endMonthYear = dayjs(dates[1]).format('MMMM YYYY');
      setSelectedDates(dates);

      const apiPayload = {
        startMonthYear,
        endMonthYear,
      };
      // console.log('Payload for API:', apiPayload);
    } else {
      // console.log('No dates selected');
    }
  };

  const allOptions = [
    { value: 'avg_monthly_searches', label: 'Avg. monthly searches' },
    { value: 'competition_enum', label: 'Competition' },
    { value: 'low_top_of_page_bid', label: 'Top Of The Page Bid (Low range)' },
    { value: 'high_top_of_page_bid', label: 'Top Of The Page Bid (High range)' },
    { value: 'competition_index', label: 'Competition (Index Value)' },
    { value: 'volume_rank', label: 'Volume Rank' },
    { value: 'competition_rank', label: 'Competition Rank' },
    { value: 'bid_rank', label: 'Bid Rank' },
    { value: 'overall_rank', label: 'Overall Rank' },
  ];

  // Initialize column visibility with all columns visible
  const initialColumnVisibility = allOptions.reduce((acc, option) => {
    acc[option.value] = true;
    return acc;
  }, {});

  // const App = () => {
  const [selectedServices, setSelectedServices] = useState(allOptions.map(option => option.value));
  const [columnVisibility, setColumnVisibility] = useState(initialColumnVisibility);

  const handleServiceChange = (selectedValues) => {
    setSelectedServices(selectedValues);

    // Update column visibility based on selection
    const updatedColumnVisibility = { ...initialColumnVisibility };
    allOptions.forEach(option => {
      updatedColumnVisibility[option.value] = selectedValues.includes(option.value);
    });

    setColumnVisibility(updatedColumnVisibility);
  };

  const columns = [
    {
      title: <Tooltip title="Keyword description"><span className="cursor-help">Keyword</span></Tooltip>,
      dataIndex: "keyword",
      key: "keyword",
      fixed: 'left', // Keep keyword column fixed on the left
      sorter: (a, b) => a.keyword.localeCompare(b.keyword),
    },
    {
      title: <Tooltip title="Average monthly searches (“Avg. monthly searches”) shows the average number of searches for this keyword and its close variants based on the month range as well as the location and Search Network settings you selected. You can use this information to see how popular your keywords are during different times of the year."><span className="cursor-help">Avg. monthly searches</span></Tooltip>,
      dataIndex: "avg_monthly_searches",
      key: "avg_monthly_searches",
      align: "center",
      sorter: (a, b) => a.avg_monthly_searches - b.avg_monthly_searches,
      hidden: !columnVisibility['avg_monthly_searches'],
    },
    {
      title: <Tooltip title="'Competition' shows how competitive ad placement is for a keyword, specific to the location and Search Network targeting options that you've selected. The level of competition  low, medium or high  is determined by the number of advertisers bidding on each keyword relative to all keywords across Google. If we don't have enough data, you'll see a dash (-)."><span className="cursor-help">Competition</span></Tooltip>,
      dataIndex: "competition_enum",
      key: "competition_enum",
      align: "center",
      sorter: (a, b) => a.competition_enum.localeCompare(b.competition_enum),
      hidden: !columnVisibility['competition_enum'],
    },
    {
      title: <Tooltip title="“Top of page bid (low range)” shows the lower range of what advertisers have historically paid for a keyword top of page bid, based on your location and Search Network settings. The average CPC of your keywords may vary."><span className="cursor-help">Top Of The Page Bid (Low range)</span></Tooltip>,
      dataIndex: "low_top_of_page_bid",
      key: "low_top_of_page_bid",
      align: "center",
      render: (value) => `$${value.toFixed(2)}`,
      sorter: (a, b) => a.low_top_of_page_bid - b.low_top_of_page_bid,
      hidden: !columnVisibility['low_top_of_page_bid'],
    },
    {
      title: <Tooltip title="“Top of page bid (high range)” shows the higher range of what advertisers have historically paid for a keywords top of page bid, based on your location and Search Network settings. The average CPC of your keywords may vary."><span className="cursor-help">Top Of The Page Bid (High range)</span></Tooltip>,
      dataIndex: "high_top_of_page_bid",
      key: "high_top_of_page_bid",
      align: "center",
      render: (value) => `$${value.toFixed(2)}`,
      sorter: (a, b) => a.high_top_of_page_bid - b.high_top_of_page_bid,
      hidden: !columnVisibility['high_top_of_page_bid'],
    },
    {
      title: <Tooltip title="Competition (indexed value) shows how competitive ad placement is for a keyword, specific to the location and Search Network targeting options that you've selected. The level of competition from 0-100 is determined by the number of ad slots filled divided by the total number of ad slots available. If not enough data is available, you'll see a dash (-)."><span className="cursor-help">Competition (Index Value)</span></Tooltip>,
      dataIndex: "competition_index",
      key: "competition_index",
      align: "center",
      sorter: (a, b) => a.competition_index - b.competition_index,
      hidden: !columnVisibility['competition_index'],
    },
    {
      title: <Tooltip title="This ranks keywords based on their average monthly search volume (avg_monthly_searches) in descending order. A lower rank value (e.g., 1) indicates higher search volume and greater popularity among users."><span className="cursor-help">Volume Rank</span></Tooltip>,
      dataIndex: "volume_rank",
      key: "volume_rank",
      align: "center",
      sorter: (a, b) => a.volume_rank - b.volume_rank,
      hidden: !columnVisibility['volume_rank'],
    },
    {
      title: <Tooltip title="This ranks keywords based on the level of advertiser competition (competition_enum). The competition is converted to numeric values (LOW = 1, MEDIUM = 2, HIGH = 3), and the rank is assigned in ascending order. Lower numeric values correspond to less competitive keywords, and they are ranked higher."><span className="cursor-help">Competition Rank</span></Tooltip>,
      dataIndex: "competition_rank",
      key: "competition_rank",
      align: "center",
      sorter: (a, b) => a.competition_rank - b.competition_rank,
      hidden: !columnVisibility['competition_rank'],
    },
    {
      title: <Tooltip title="This ranks keywords based on the average of the low and high top-of-page bid estimates (low_top_of_page_bid and high_top_of_page_bid) in descending order. Higher average bids are ranked higher, as they often indicate higher commercial value or advertiser demand."><span className="cursor-help">Bid Rank</span></Tooltip>,
      dataIndex: "bid_rank",
      key: "bid_rank",
      align: "center",
      sorter: (a, b) => a.bid_rank - b.bid_rank,
      hidden: !columnVisibility['bid_rank'],
    },
    {
      title: <Tooltip title="This is a weighted rank calculated by combining the Volume Rank, Competition Rank, and Bid Rank with specific weights (50% for Volume Rank, 30% for Competition Rank, and 20% for Bid Rank). The final rank is normalized and rounded to two decimal places."><span className="cursor-help">Overall Rank</span></Tooltip>,
      dataIndex: "overall_rank",
      key: "overall_rank",
      render: (text) => <p>{Number(text).toFixed(1)}</p>,
      align: "center",
      sorter: (a, b) => a.overall_rank - b.overall_rank,
      hidden: !columnVisibility['overall_rank'],
    }
  ];

  const handleDownload = () => {
    // const dataToExport = sortedKeywords.map(item => {
    //   const row = {};
    //   columns.forEach(column => {
    //     if (!column.hidden) {
    //       let value = item[column.dataIndex];
    //       if (column.dataIndex === 'low_top_of_page_bid' || column.dataIndex === 'high_top_of_page_bid') {
    //         value = `$${value.toFixed(2)}`;
    //       } else if (column.dataIndex === 'overall_rank') {
    //         value = Number(value).toFixed(1);
    //       }
    //       row[column.title.props.children.props.children] = value;
    //     }
    //   });
    //   return row;
    // });
    // const ws = XLSX.utils.json_to_sheet(dataToExport);
    // const colWidths = columns
    //   .filter(col => !col.hidden)
    //   .map(col => ({ wch: Math.max(col.title.props.children.props.children.length, 15) }));
    // ws['!cols'] = colWidths;
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Keywords');

    // XLSX.writeFile(wb, 'keywords.xlsx');
  };


  const [activeTab, setActiveTab] = useState('keyword')
  // console.log(activeTab);

  const [websiteURL, setWebsiteURL] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem('suggestionurl');
      return saved ? JSON.parse(saved) : '';
    }
    return '';
  })
  const [seedKeywords, setSeedKeywords] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem('seedKeywords');
      return saved ? JSON.parse(saved) : [];
    }
    return '';
  })
  const [inputValue, setInputValue] = useState('');

  const addKeyword = useCallback((keyword) => {
    setSeedKeywords((prevKeywords) => {
      if (!keyword.trim()) {
        toast.error("Keyword cannot be empty.");
        return prevKeywords;
      }

      if (prevKeywords.length >= 10) {
        toast.error("You can only add up to 10 keywords.");
        return prevKeywords;
      }

      if (prevKeywords.includes(keyword.trim())) {
        toast.error("This keyword already exists.");
        return prevKeywords;
      }

      return [...prevKeywords, keyword.trim()];
    });
  }, []);


  const removeKeyword = useCallback((keywordToRemove) => {
    setSeedKeywords(prevKeywords => prevKeywords.filter(keyword => keyword !== keywordToRemove))
  }, [])

  const handleKeyInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      const values = inputValue.split(',').map(v => v.trim()).filter(Boolean)
      values.forEach(addKeyword)
      setInputValue('')
    }
  };
  const handlePaste = (e) => {
    e.preventDefault()
    const pasteData = e.clipboardData.getData('Text')
    const pastedKeywords = pasteData
      .split(/[\n,]/)
      .map(k => k.trim())
      .filter(Boolean)

    setSeedKeywords(prevKeywords => {
      const newKeywords = [...prevKeywords]
      pastedKeywords.forEach(keyword => {
        if (newKeywords.length < 10 && !newKeywords.includes(keyword)) {
          newKeywords.push(keyword)
        }
      })
      return newKeywords
    })

    setInputValue('')
  }

  const [selectedCountries, setSelectedCountries] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem('selectedCountries');
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  })

  const [loading, setLoading] = useState(false)
  const [suggestedKeywords, setSuggestedKeywords] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = sessionStorage.getItem('suggestedKeywords');
      return saved ? JSON.parse(saved) : []; // Default to empty array for keywords
    }
    return []; // Default to empty array if window is undefined
  });

  useEffect(() => {
    if (suggestedKeywords?.length) {
      sessionStorage.setItem('suggestedKeywords', JSON.stringify(suggestedKeywords));
    }
    if (selectedCountries?.length) {
      sessionStorage.setItem('selectedCountries', JSON.stringify(selectedCountries));
    }
    if (websiteURL) {
      sessionStorage.setItem('suggestionurl', JSON.stringify(websiteURL)); // Save website URL to sessionStorage
    }
    if (seedKeywords) {
      sessionStorage.setItem('seedKeywords', JSON.stringify(seedKeywords)); // Save website URL to sessionStorage
    }
  }, [suggestedKeywords, websiteURL, seedKeywords, selectedCountries]);

  const sortedKeywords = suggestedKeywords.sort((a, b) => {
    return b.is_requested_keyword - a.is_requested_keyword;
  });

  const [duration, setDuration] = useState("3months");

  // const handleChangeDuration = (value) => {
  //   setDuration(value);
  // };

  const handleChangeDuration = (value) => {
    setDuration(value);
    let monthsTosub = 3;

    if (value === '6months') {
      monthsTosub = 6;
    } else if (value === '1year') {
      monthsTosub = 12;
    }

    const newEndDate = dayjs(selectedDates[0]).subtract(monthsTosub, 'month');
    setSelectedDates([selectedDates[0], newEndDate]);
  };

  const handleGetResults = async () => {
    // const access_token = Cookies.get("login_access_token_appw3");
    if (
      (activeTab === 'keyword' &&
        // selectedLocations.length > 0 &&
        seedKeywords.length > 0) ||
      (activeTab === 'website' &&
        // selectedLocations.length > 0 &&
        websiteURL.trim() !== '')
    ) {
      setLoading(true);
      try {
        // console.log("start");
        const payload = {
          url: websiteURL,
          // language: 'english',
          search_by: activeTab,
          countries: selectedLocations,
          paid_user: false,
          all_locations: selectedLocations.length > 0 ? false : true,
          by_url: false,
          language: selectedLanguage.id || 'english',
          // duration: duration,
          start_date: startMonthYear,
          end_date: endMonthYear,
        };
        if (activeTab === 'keyword') {
          payload.seed_keywords = seedKeywords;
        }
        const response = await axios.post('https://www.w3era.com/api/keyword-research/', payload
        );
        // console.log("the data is ", response.data.data);
        setSuggestedKeywords(response.data.data || []);

      } catch (error) {
        // //console.error('Error fetching suggested keywords:', error);
      } finally {
        setLoading(false);
      }
    }
    else {
      toast.error('Please fill all the required fields');
    }
  };


  const [searchTerm, setSearchTerm] = useState("");
  // console.log(searchTerm);
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsLength, setSuggestionsLength] = useState(false);
  const [fetchingcont, setfetchingcont] = useState(false);
  useEffect(() => {
    setSuggestionsLength(suggestions.length > 0);
  }, [suggestions]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const inputRef = useRef(null);
  // console.log(suggestions);
  // console.log(activeTab,selectedCountries,seedKeywords, selectedLocations);
  const [language, setlanguage] = useState([])

  useEffect(() => {
    if (searchTerm.trim().length >= 3) {
      const fetchSuggestions = async () => {
        try {
          setfetchingcont(true);
          const response = await axios.get(
            `https://onpageinsights.com/api/search-locations/?search_term=${searchTerm}`
          );
          setSuggestions(response.data.data || []); // Adjust based on API structure
        } catch (error) {
          // //console.error('Error fetching locations:', error);
        }
        finally {
          setfetchingcont(false);
        }
      };
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  },
    [searchTerm]);
  // console.log('selected origin is ', searchTerm);

  useEffect(() => {
    // if (searchTerm.trim().length >= 3) {
    const fetchSuggestions = async () => {
      try {
        // setfetchingcont(true);
        const response = await axios.get(
          `https://onpageinsights.com/api/get-languages/`
        );
        // console.log('the languages are', response.data)
        setlanguage(response.data || []); // Adjust based on API structure
      } catch (error) {
        // //console.error('Error fetching locations:', error);
      }
      // finally {
      //   setfetchingcont(false);
      // }
    };
    fetchSuggestions();
    //   } else {
    //     setSuggestions([]);
    //   }
    // },
  }
    , [searchTerm]);

  const handleSelect = (country) => {
    if (!selectedLocations.some((location) => location.id === country.id)) {
      const updatedLocations = [...selectedLocations, country];
      setSelectedLocations(updatedLocations);
      setSearchTerm('');
      setSuggestions([]);
      inputRef.current.focus();
    }
  };
  const [selectedLanguage, setselectedLanguage] = useState([])

  const handleSelectLanguage = (country) => {
    // if (!selectedLocations.some((location) => location.id === country.id)) {
    // const updatedLocations = [...se, country];
    setselectedLanguage(country);
    // setSearchTerm('');
    // setSuggestions([]);
    // inputRef.current.focus();
    // }
  };
  // console.log('selected language code is ', selectedLanguage)
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleRemoveLocation = (id) => {
    setSelectedLocations(selectedLocations.filter(location => location.id !== id));
  };
  // const handleRemoveLocation = (id) => {
  //   setSelectedLocations(selectedLocations.filter(location => location.id !== id));
  // };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className=" bg-white"
      onClick={() => setSuggestionsLength(false)}
    >
      {/* <h3 className="text-3xl md:text-4xl font-bold mb-6 md:text-start text-center text-blue">Keyword Suggestions</h3> */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-lg shadowop "
      >
        <div className="">

          <div className="border-b mb-6">
            <div className="flex gap-8">
              <button
                onClick={() => setActiveTab('keyword')}
                className={`pb-4 px-1 relative font-medium ${activeTab === 'keyword' ? 'text-blue ' : 'text-homeblack'}`}
              >
                Start with keywords
                {activeTab === 'keyword' && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue"
                  />
                )}
              </button>
              <button
                onClick={() => setActiveTab('website')}
                className={`pb-4 px-1 relative font-medium ${activeTab === 'website' ? 'text-blue' : 'text-homeblack'}`}
              >
                Start with a website
                {activeTab === 'website' && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue"
                  />
                )}
              </button>
            </div>
          </div>
          {activeTab === 'keyword' ? (
            <div className="space-y-6">
              <div>
                <label className="flex items-center gap-2 text-sm font-bold text-homeblack mb-2">
                  Enter products or services closely related to your business <MdStar className="text-red-500" />
                </label>
                <div className="mb-4">
                  <div className="flex flex-wrap gap-2">
                    <AnimatePresence>
                      {seedKeywords && seedKeywords.map((keyword, index) => (
                        <motion.div
                          key={keyword}
                          className="flex items-center px-3 py-1 bg-lightpink rounded-full text-sm font-medium text-pink"
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.8 }}
                          transition={{ duration: 0.2 }}
                        >
                          {keyword}
                          <button
                            className="ml-2  hover:text-red-700"
                            onClick={() => removeKeyword(keyword)}
                          >
                            ×
                          </button>
                        </motion.div>
                      ))}
                    </AnimatePresence>
                  </div>
                </div>
                <input
                  type="text"
                  placeholder='Try "meal delivery" or "leather boots"'
                  className="w-full px-3 py-2 bg-lightblue rounded-md outline-none focus:ring-2 focus:ring-blue"
                  value={inputValue}
                  onChange={handleKeyInputChange}
                  onKeyUp={handleInputKeyPress}
                  onPaste={handlePaste}
                />
                <p className="mt-2 text-sm text-homeblack">
                  Be concise. Use specific terms like meal delivery, not meals.<span className='font-bold'> Separate keywords with Commas or press Enter</span>.
                </p>
              </div>
              <div>
                <label className="block text-sm font-bold text-homeblack mb-2">
                  Enter a site to filter unrelated keywords
                </label>
                <input
                  type="text"
                  placeholder="https://"
                  className="w-full px-3 py-2 bg-lightblue rounded-md outline-none    focus:ring-2 focus:ring-blue"
                  value={websiteURL}
                  onChange={(e) => setWebsiteURL(e.target.value)}
                />
                <p className="mt-2 text-sm text-homeblack">
                  Using your site will filter out services, products or brands that you dont offer
                </p>
              </div>
            </div>
          )
            :
            (
              <div className="space-y-6">
                <div>
                  <label className="flex items-center gap-2 text-sm font-bold text-homeblack mb-2">
                    Enter a website or a page to find keywords that match your site <MdStar className=' text-red-500' />
                  </label>
                  <input
                    type="text"
                    placeholder="https://"
                    className="w-full px-3 py-2 bg-lightblue rounded-md outline-none focus:ring-2 focus:ring-blue "
                    value={websiteURL}
                    onChange={(e) => setWebsiteURL(e.target.value)}
                  />
                  <p className="mt-2 text-sm text-homeblack">
                    Use a website as a source of keywords
                  </p>
                </div>
              </div>
            )}


          <div className=" w-full">
            <motion.div
              className="flex flex-row gap-6 w-full"
              initial="hidden"
              animate="visible"
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: {
                    staggerChildren: 0.2,
                    delayChildren: 0.5,
                  },
                },
              }}
            >
              {/* Locations */}
              <motion.div className="mt-7 bg-white p-6 rounded-lg shadow-md max-w-md w-full animate-fadeIn">
                <div className="flex items-center gap-4 text-sm text-gray-700 mb-4">
                  <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center">📍</span>
                  <span className="font-semibold">Select location</span>
                  <MdStar className="text-red-500" />
                </div>
                <div className="relative w-full">
                  <div className="flex gap-2 items-center">
                    <input
                      ref={inputRef}
                      type="text"
                      placeholder="Type a location name.. (default all locations selected)"
                      value={searchTerm}
                      onChange={handleInputChange}
                      className="w-full bg-lightblue rounded-md px-4 py-2 text-sm font-light text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue"
                    />
                    {fetchingcont && <Spin />}
                  </div>
                  <div className="flex flex-wrap gap-2 mt-3">
                    {selectedLocations.map((location) => (
                      <span key={location.id} className="bg-lightpink text-pink px-3 py-1 rounded-full text-sm flex items-center">
                        {location.name}
                        <button onClick={() => handleRemoveLocation(location.id)} className="ml-2 text-pink hover:text-red">
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                  {suggestionsLength && (
                    <ul className="absolute z-10 mt-2 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto w-full">
                      {suggestions.map((country) => (
                        <li
                          key={country.id}
                          onClick={() => handleSelect(country)}
                          className={`px-4 py-2 cursor-pointer hover:bg-lightpink hover:text-pink ${selectedLocations.some((location) => location.id === country.id) ? "bg-lightpink text-pink" : ""}`}
                        >
                          {country.name} ({country.country_code})
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </motion.div>

              {/* Language Selection */}
              <Tooltip title={<span>Please <Link href="https://app.w3era.com/signin" target='_blank' className='text-blue font-semibold'>Login</Link> To Continue Using More Filters</span>}>
                <motion.div
                  disabled
                  className="mt-6 bg-white p-6 rounded-lg shadow-md max-w-md w-full animate-fadeIn disabled:cursor-not-allowed">
                  <div className="flex items-center gap-4 text-sm text-gray-700 mb-4">
                    <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center">🌍</span>
                    <span className="font-semibold">English (default)</span>
                  </div>
                  <div className="relative w-full">
                    <div className="flex gap-2 items-center">
                      <input
                        ref={inputRef}
                        type="text"
                        placeholder="Type a language name..."
                        // value={selectedLanguage.name}
                        // onClick={() => setshowlanguage(true)}
                        disabled
                        className="w-full bg-[#0000000A] text-[#00000040] text-sm font-light rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue disabled:cursor-not-allowed"
                      />
                      {/* {fetchingcont && <Spin />} */}
                    </div>
                    {language.length > 0 && showlanguage && (
                      <ul className="absolute z-10 mt-2 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto w-full">
                        {language.map((lang) => (
                          <li
                            key={lang.id}
                            onClick={() => {
                              handleSelectLanguage(lang);
                              setshowlanguage(false);
                            }}
                            className="px-4 py-2 cursor-pointer hover:bg-lightpink hover:text-pink"
                          >
                            {lang.name} ({lang.code})
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </motion.div></Tooltip>

              {/* Duration Picker */}
              <Tooltip title={<span>Please <Link href="https://app.w3era.com/signin" target='_blank' className='text-blue font-semibold'>Login</Link> To Continue Using More Filters</span>}>
                <motion.div className="mt-6 bg-white p-6 rounded-lg shadow-md max-w-md w-full animate-fadeIn">
                  <div className="flex items-center gap-4 text-sm text-gray-700 mb-4">
                    <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center">📅</span>
                    <span className="font-semibold">Select Duration</span>
                    <MdStar className="text-red-500" />
                  </div>
                  <div className="relative w-full">
                    <Select
                      disabled
                      defaultValue="3months" style={{ width: '100%' }}
                    //  onChange={handleChangeDuration}
                    >
                      <Option value="3months">3 Months</Option>
                      <Option value="6months">6 Months</Option>
                      <Option value="1year">1 Year</Option>
                    </Select>
                  </div>
                </motion.div></Tooltip>

              {/* Date Picker */}
              <Tooltip title={<span>Please <Link href="https://app.w3era.com/signin" target='_blank' className='text-blue font-semibold'>Login</Link> To Continue Using More Filters</span>}>
                <motion.div className="mt-6 bg-white p-6 rounded-lg shadow-md max-w-md w-full animate-fadeIn">
                  <div className="flex items-center gap-4 text-sm text-gray-700 mb-4">
                    <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center">📅</span>
                    <span className="font-semibold">Select Date Range</span>
                    <MdStar className="text-red-500" />
                  </div>
                  <div className="relative w-full">
                    <Space direction="vertical" size={12}>
                      <RangePicker
                        // defaultValue={[dayjs("2015/01/01", dateFormat), dayjs("2015/01/01", dateFormat)]} 
                        disabled
                        value={selectedDates}
                        format={dateFormat}
                      // onChange={handleDateChange} 
                      />
                    </Space>
                  </div>
                </motion.div></Tooltip>

            </motion.div>
          </div>


          <div className="mt-6 flex justify-between items-center ">
            <button
              onClick={handleGetResults}
              disabled={loading}
              className="px-8 py-2  h-fit bg-pink text-white rounded-lg flex items-center justify-center gap-2 hover:scale-105 smooth3 transition-colors w-1/6"
            >
              {loading ? 'Getting results...' : 'Get results'}
            </button>
            {suggestedKeywords?.length > 0 && (
              <div className='flex gap-2 2xl:w-1/3 w-1/2  items-center '>
                <Tooltip title={<span>Please <Link href="https://app.w3era.com/signin" target='_blank' className='text-blue font-semibold'>Login</Link> To Continue Using More Filters</span>}>
                  <div className='w-full flex pb-3 '>
                    <div className="relative max-w-md w-full flex flex-col gap-1 " >
                      <label name="select_services" htmlFor="select_services"> Fields To Hide</label>
                      <Select
                        mode="multiple"
                        placeholder="Select columns to Hide"
                        disabled
                        // onChange={handleServiceChange}
                        // value={selectedServices}
                        options={allOptions}
                        maxTagCount="responsive"
                        className="w-full "

                      />

                    </div>
                  </div></Tooltip>

                <Tooltip title={<span>Please <Link href="https://app.w3era.com/signin" target='_blank' className='text-blue font-semibold'>Login</Link> To Continue Using More Filters</span>}>
                  <button
                    // onClick={handleDownload}
                    disabled
                    className='px-8 py-2 ml-4 w-full disabled:cursor-not-allowed h-fit bg-white border border-pink text-pink rounded-lg flex items-center justify-center  gap-2 hover:scale-105 smooth3 transition-colors '>
                    Download Report
                  </button></Tooltip>
              </div>
            )}
          </div>
        </div>
        {loading &&
          <div className='flex w-full my-2'>
            <Spin className='w-full flex justify-center items-center my-4  ' /></div>}
        {suggestedKeywords?.length > 0 && (
          <div className=" relative overflow-x-auto">

            <Table
              columns={columns.filter(column => column.dataIndex === 'keyword' || columnVisibility[column.dataIndex])}
              dataSource={sortedKeywords}
              loading={loading}
              rowKey={(record, index) => index}
              showSorterTooltip={{ target: 'sorter-icon' }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: 50,
                onChange: handlePageChange,
                showSizeChanger: true,
              }}
              scroll={{ x: '100%' }}
            />
          </div>
        )}
        {/* </div> */}
      </motion.div>
    </motion.div>
  )
}

